<template>


    <form :action="actionPage" method="post" name="register_form">

        <input type="hidden" name="_token" :value="csrf_token">
        <input type="hidden" name="avoid_duplicate" :value="avoid_duplicate">

        <p class="u-text-center">
            <span :class="currentStep === 1 ? '' : 'u-color-muted'">기본</span>
            -
            <span :class="currentStep === 2 ? '' : 'u-color-muted'">티켓</span>
            -
            <span :class="currentStep === 3 ? '' : 'u-color-muted'">금액</span>
            -
            <span :class="currentStep === 4 ? '' : 'u-color-muted'">결제 방법</span>
        </p>

        <table class="c-form-table-2  js-step-container" v-show="currentStep === 1">
            <tbody>
            <tr>
                <th nowrap><label for="name">이름*</label></th>
                <td>
                    <input class="u-12/12" id="name" name="name" required type="text"
                           v-model="name">
                </td>
            </tr>
            <tr>
                <th nowrap><label for="is_member_of">소속</label></th>
                <td>
                    <input class="u-12/12" id="is_member_of" name="is_member_of" type="text"
                           v-model="is_member_of">
                    <div class="u-text-small">
                        (직장/학교/단체/노동조합 등)
                    </div>
                </td>
            </tr>
            <tr>
                <th nowrap><label for="phone">휴대폰*</label></th>
                <td>
                    <input class="u-12/12" id="phone" name="phone" pattern="[0-9\-]+" placeholder="010-1234-1234"
                           required
                           title="숫자와 -만 입력하세요." type="text"
                           v-model="phone">
                </td>
            </tr>
            <tr>
                <th scope="row">연락*</th>
                <td>
                    <div>
                        주최 단체인 ‘노동자연대’로부터 연락을 받으시겠습니까?
                    </div>

                    <label class="u-margin-right-small">
                        <input required type='radio' name='allow_contact' value='수락' v-model="allow_contact">
                        예
                    </label>
                    <label class="u-margin-right-small">
                        <input required type='radio' name='allow_contact' value='거절' v-model="allow_contact">
                        아니오
                    </label>
                    <label>
                        <input required type='radio' name='allow_contact' value='받고 있음' v-model="allow_contact">
                        이미 받고 있음
                    </label>

                    <div class='u-text-tiny  u-color-muted'>
                        노동자연대는 각 지역(서울 8곳, 수원, 인천, 제천, 부산, 울산)과 대학에서 마르크스주의 사상과 국내외 정치 쟁점들,
                        노동자·사회 운동의 현안 등을 주제로 공개 토론 모임을 엽니다.<br> 연락에 동의하시면 앞으로 토론회 등의 행사를 안내해드립니다.
                    </div>
                </td>
            </tr>
            <tr>
                <th nowrap><label for="email">이메일*</label></th>
                <td>
                    <div class="u-margin-bottom-tiny">
                        <input class="u-12/12" id="email" name="email" placeholder="your-mail@test.com" required
                               type="email"
                               v-model="email">
                    </div>
                    <ul class='u-text-tiny  u-color-muted  u-margin-bottom-tiny  u-margin-left-small'>
                        <li>장소, 발제자, 강연 추가 및 변동 등 {{ marxism.title }} 중요 공지사항을 메일로 보내드립니다.</li>
                        <li>웹사이트에서 신청 결과 확인시 이메일 주소가 아이디로 사용됩니다.</li>
                    </ul>
                    <label class="u-text-small">
                        <input false-value="n" true-value="y" type='checkbox' v-model="mailing">
                        <input name="mailing" type="hidden" v-model="mailing">
                        노동자연대가 개최하는 공개 토론회 및 주요 일정 소식을 이메일로 받겠습니다.
                    </label>
                </td>
            <tr>
                <th nowrap><label for="remark">문의/남길말</label></th>
                <td>
                    <textarea class="u-12/12" id="remark" name="remark" rows="3" v-model="remark"></textarea>
                </td>
            </tr>
            <tr>
                <th></th>
                <td>
                    <label for="survey">{{ marxism.title }}를 어떻게 알게 되었나요?</label>
                    <select id="survey" name="survey" v-model="survey">
                        <option value="">선택하세요</option>
                        <option>전에 맑시즘에 참가한 적이 있다.</option>
                        <option>친구/동료/가족 소개로 알았다.</option>
                        <option>포스터를 봤다.</option>
                        <option>전단지를 봤다.</option>
                        <option>SNS에서 광고물을 봤다.</option>
                        <option>현수막을 봤다.</option>
                        <option>광고 이메일 또는 전화를 받았다.</option>
                        <option>노보, 소식지, 신문 등에 실린 광고를 봤다.</option>
                        <option>기타</option>
                    </select>
                    <input :class="survey !== '기타' ? 'u-hidden' : ''" class="u-12/12" name="survey_direct"
                           placeholder="기타 내용을 입력해 주세요."
                           type="text"
                           v-model="survey_direct">
                </td>
            </tr>
            </tbody>
        </table>

        <transition name="fade">
            <table class="c-form-table-2  js-step-container" v-show="currentStep === 2">
                <tbody>
                <tr>
                    <th nowrap><label for="ticket_full_count">나흘</label></th>
                    <td>
                        <input @blur="ticket_full_count = ticket_full_count || 0" @focus="$event.target.select()"
                               class="u-3/12  u-text-right"
                               id="ticket_full_count" min="0"
                               name="ticket_full_count"
                               type="number"
                               v-model.number="ticket_full_count">매
                    </td>
                </tr>
                <tr>
                    <th nowrap><label for="ticket_1_count">22일(목)</label></th>
                    <td>
                        <input @blur="ticket_1_count = ticket_1_count || 0" @focus="$event.target.select()"
                               class="u-3/12  u-text-right" id="ticket_1_count"
                               min="0"
                               name="ticket_1_count"
                               type="number"
                               v-model.number="ticket_1_count">매
                    </td>
                </tr>
                <tr>
                    <th nowrap><label for="ticket_2_count">23일(금)</label></th>
                    <td>
                        <input @blur="ticket_2_count = ticket_2_count || 0" @focus="$event.target.select()"
                               class="u-3/12  u-text-right" id="ticket_2_count"
                               min="0"
                               name="ticket_2_count"
                               type="number"
                               v-model.number="ticket_2_count">매
                    </td>
                </tr>
                <tr>
                    <th nowrap><label for="ticket_3_count">24일(토)</label></th>
                    <td>
                        <input @blur="ticket_3_count = ticket_3_count || 0" @focus="$event.target.select()"
                               class="u-3/12  u-text-right" id="ticket_3_count"
                               min="0"
                               name="ticket_3_count"
                               type="number"
                               v-model.number="ticket_3_count">매
                    </td>
                </tr>
                <tr>
                    <th nowrap><label for="ticket_4_count">25일(일)</label></th>
                    <td>
                        <input @blur="ticket_4_count = ticket_4_count || 0" @focus="$event.target.select()"
                               class="u-3/12  u-text-right" id="ticket_4_count"
                               min="0"
                               name="ticket_4_count"
                               type="number"
                               v-model.number="ticket_4_count">매
                    </td>
                </tr>
                <tr>
                    <th nowrap>할인</th>
                    <td>
                        <div>
                            <label>
                                <input id="pricing_기본" name="pricing" type="radio" v-model="pricing"
                                       value="기본">
                                해당 사항 없음
                            </label>
                        </div>
                        <div>
                            <label>
                                <input id="pricing_대학생" name="pricing" type="radio" v-model="pricing"
                                       value="대학생">
                                대학생(학부생)
                            </label>
                        </div>
                        <div v-if="['대학생', '마르크스주의ABC 참가자'].indexOf(pricing) > -1">
                            <label>
                                <input id="pricing_마르크스주의ABC_참가자" name="pricing" type="radio" v-model="pricing"
                                       value="마르크스주의ABC 참가자">
                                마르크스주의ABC 참가자
                            </label>
                        </div>
                        <div>
                            <label>
                                <input id="pricing_청년실업자" name="pricing" type="radio" v-model="pricing"
                                       value="청년실업자">
                                청년실업자
                            </label>
                        </div>
                        <div>
                            <label>
                                <input id="pricing_청소년" name="pricing" type="radio" v-model="pricing"
                                       value="청소년">
                                청소년
                            </label>
                        </div>
                        <div>
                            <label>
                                <input id="pricing_이주노동자" name="pricing" type="radio" v-model="pricing"
                                       value="이주노동자">
                                이주노동자·난민
                            </label>
                        </div>
                        <div>
                            <label>
                                <input id="pricing_장기투쟁작업장" name="pricing" type="radio" v-model="pricing"
                                       value="장기투쟁작업장">
                                장기투쟁작업장 노동자
                            </label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th nowrap>
                        금액 합계
                    </th>
                    <td>
                        {{ amountWithComma }}원
                    </td>
                </tr>
                </tbody>
            </table>
        </transition>

        <transition name="fade">
            <table class="c-form-table-2  js-step-container" v-show="currentStep === 3">
                <tbody>
                <tr>
                    <th>후원</th>
                    <td class="u-text-keep-words">
                        <p>
                            {{ marxism.title }} 후원금으로
                            <input @blur="donation = donation || 0" @focus="$event.target.select()"
                                   class="u-text-right  u-3/12" id="donation"
                                   name="donation" pattern="[0-9]*"
                                   title="숫자만 입력해 주세요."
                                   type="text"
                                   v-model="donation">원을 더 지불하겠습니다.
                        </p>
                        <p>지난 20년간 한국에서 맑시즘을 개최할 수 있었던 힘은 맑시즘에 보내주신 여러분들의 지지 덕분이었습니다.</p>
                        <p class="u-text-small">
                            {{ marxism.title }}는 정부나 기업의 후원을 일절 받지 않습니다.<br>
                            오직 참가자들의 참가비와 후원금 그리고 진보·좌파 단체와 노동조합의
                            후원금만으로 운영합니다.<br>
                            여러분의 후원금은 이후 맑시즘을 지속하는 데 커다란 힘이 됩니다.
                        </p>
                    </td>
                </tr>
                <tr>
                    <th nowrap>
                        금액 합계
                    </th>
                    <td>
                        {{ amountWithComma }}원
                    </td>
                </tr>
                </tbody>
            </table>
        </transition>

        <transition name="fade">
            <table class="c-form-table-2  js-step-container" v-show="currentStep === 4">
                <tbody>
                <tr>
                    <th nowrap>
                        금액 합계
                    </th>
                    <td>
                        {{ amountWithComma }}원
                    </td>
                </tr>
                <tr>
                    <th nowrap>결제 방법</th>
                    <td>
                        <label>
                            <input name="pay_type" type="radio" v-model="pay_type" value="카드">
                            카드
                        </label>
                        <label>
                            <input name="pay_type" type="radio" v-model="pay_type" value="계좌이체">
                            계좌이체
                        </label>
                    </td>
                </tr>
                <tr v-if="pay_type === '계좌이체'">
                    <th nowrap>
                        <label for="depositor">입금자명</label>
                    </th>
                    <td>
                        <input class="u-12/12" id="depositor" name="depositor" required type="text"
                               v-model="depositor">
                        <button @click="depositor = name" class="c-btn  c-btn--default  c-btn--size-small u-text-tiny"
                                type="button">
                            이름과 같음
                        </button>
                    </td>
                </tr>
                <tr v-if="pay_type === '계좌이체'">
                    <td colspan="2">
                        보낼 계좌: 국민은행 017001-04-089255 (백은진)
                        <input name="bank" type="hidden" v-model="bank" value="국민은행">
                    </td>
                </tr>
                <tr v-if="pay_type === '계좌이체'">
                    <th nowrap>
                        이체 예정일
                    </th>
                    <td>
                        <div class="o-show-date-calendar">
                            <input :max="max_date_of_direct" :min="min_date_of_direct" id="pay_due" name="pay_due"
                                   required
                                   type="date"
                                   v-model="pay_due">
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </transition>


        <p class="u-text-center" v-if="app_env === 'local'">
            <button @click="test()" type="button">테스트 입력</button>
        </p>

        <p class="u-text-center">
            <button @click="currentStep--" class="c-btn c-btn--primary" type="button" v-show="currentStep > 1">
                이전
            </button>
            <button @click="nextStep()" class="c-btn c-btn--primary" type="button" v-show="currentStep < 4">
                다음
            </button>
            <button class="c-btn c-btn--primary  c-btn--size-large" type="submit"
                    v-show="currentStep === 4">
                참가신청
            </button>
        </p>
    </form>

</template>

<script>
    export default {
        name: "RegisterForm",
        props: ['marxism'],
        data() {
            return {
                name: '',
                is_member_of: '',
                phone: '',
                email: '',
                mailing: 'n',
                remark: '',
                survey: '',
                survey_direct: '',
                ticket_1_count: 0,
                ticket_2_count: 0,
                ticket_3_count: 0,
                ticket_4_count: 0,
                ticket_full_count: 0,
                avoid_duplicate: Math.random().toString(36).slice(2),
                csrf_token: document.querySelector('[name="csrf-token" ]').content,
                pricing: '기본',
                donation: 0,
                pay_type: '카드',
                depositor: '',
                bank: '국민은행',
                pay_due: moment().format('YYYY-MM-DD'),
                currentStep: 1,
                app_env: $('#app_env').content,
                min_date_of_direct: moment().format('YYYY-MM-DD'),
                max_date_of_direct: moment().add(7, 'day').format('YYYY-MM-DD'),
                allow_contact: null
            }
        },
        computed: {
            currentPricingTickets() {
                return marxism.pricesForSale.filter(price => price.pricing === this.pricing);
            },
            ticket_1() {
                return _.find(this.currentPricingTickets, price => parseInt(price.dayMark) === 1)
            },
            ticket_2() {
                return _.find(this.currentPricingTickets, price => parseInt(price.dayMark) === 2)
            },
            ticket_3() {
                return _.find(this.currentPricingTickets, price => parseInt(price.dayMark) === 3)
            },
            ticket_4() {
                return _.find(this.currentPricingTickets, price => parseInt(price.dayMark) === 4)
            },
            ticket_full() {
                return _.find(this.currentPricingTickets, price => price.dayMark === 'full')
            },
            amount() {
                return this.ticket_1_count * this.ticket_1.price
                    + this.ticket_2_count * this.ticket_2.price
                    + this.ticket_3_count * this.ticket_3.price
                    + this.ticket_4_count * this.ticket_4.price
                    + this.ticket_full_count * this.ticket_full.price
                    + this.toNumber(this.donation);

            },
            amountWithComma() {
                return parseFloat(this.amount).toLocaleString();
            },
            actionPage() {
                if (this.pay_type === '카드') {
                    return '/register/bridge';
                } else if (this.pay_type === '계좌이체') {
                    return '/register/direct';
                }
            }
        },
        methods: {
            test() {
                this.name = '테스트';
                this.is_member_of = '소속';
                this.phone = '010-1234-1234';
                this.email = 'email@email.com';
                this.remark = "안녕하세요\n반갑습니다.";
                this.survey = "기타";
                this.survey_direct = "맑시즘을 기다려 왔습니다.";
                this.pricing = '장기투쟁작업장';
                this.pay_type = '카드';
                this.ticket_1_count = 1;
                this.donation = 500;
                this.allow_contact = '수락';
                // this.depositor = '테스트';
                // this.currentStep = 4;
            },
            toNumber(v) {
                if (!v) {
                    return 0;
                }
                return parseInt((v + '').replace(/[^0-9]/, ''));
            },
            nextStep() {
                if (this.currentStep === 2) {
                    const count = this.ticket_1_count + this.ticket_2_count
                        + this.ticket_3_count + this.ticket_4_count
                        + this.ticket_full_count;

                    if (count === 0) {
                        swal('티켓을 하나 이상 선택해 주세요.');
                        return false;
                    }

                    // 하루 티켓을 두 장 사는 것으로 안 된다.
                    let day_count = 0;
                    day_count += ((this.ticket_1_count > 0) ? 1 : 0);
                    day_count += ((this.ticket_2_count > 0) ? 1 : 0);
                    day_count += ((this.ticket_3_count > 0) ? 1 : 0);
                    day_count += ((this.ticket_4_count > 0) ? 1 : 0);

                    if (this.pricing === '마르크스주의ABC 참가자' && this.ticket_full_count === 0 && day_count === 1) {
                        swal('마르크스주의ABC 참가자 할인은 적어도 이틀 이상 참가신청을 하셔야 적용 가능합니다.');
                        return false;
                    }
                }
                if (document.forms.register_form.checkValidity()) {

                    setTimeout(function () {
                        window.scrollTo({
                            top: $('#register-form').offsetTop - 40,
                            left: 0
                        });
                    }, 300);

                    this.currentStep = Math.min(++this.currentStep, 4);

                } else {

                    let container = document.register_form.querySelector('input:invalid')
                        .closest('.js-step-container');
                    let step = $$('.js-step-container').indexOf(container) + 1;

                    if (this.currentStep !== step) {
                        this.currentStep = step;
                        setTimeout(() => {
                            document.forms.register_form.reportValidity();
                        }, 600);
                    } else {
                        document.forms.register_form.reportValidity();
                    }
                }
            }
        },
        created() {
            if (typeof marxism.saleAgain !== 'undefined') {

                this.name = marxism.saleAgain.buyer.name;
                this.is_member_of = marxism.saleAgain.buyer.isMemberOf;
                this.phone = marxism.saleAgain.buyer.phone;
                this.email = marxism.saleAgain.buyer.email;
                this.mailing = marxism.saleAgain.buyer.mailing;
                this.remark = marxism.saleAgain.remark;
                this.survey = marxism.saleAgain.survey;
                this.survey_direct = marxism.saleAgain.surveyDirect;
                this.pricing = marxism.saleAgain.pricing;
                this.pay_type = '카드';
                this.ticket_1_count = marxism.saleAgain.tickets.find((t) => t.dayMark === '1').count || 0;
                this.ticket_2_count = marxism.saleAgain.tickets.find((t) => t.dayMark === '2').count || 0;
                this.ticket_3_count = marxism.saleAgain.tickets.find((t) => t.dayMark === '3').count || 0;
                this.ticket_4_count = marxism.saleAgain.tickets.find((t) => t.dayMark === '4').count || 0;
                this.ticket_full_count = marxism.saleAgain.tickets.find((t) => t.dayMark === 'full').count || 0;
                this.donation = marxism.saleAgain.donation;
                this.allow_contact = marxism.saleAgain.allowContact;
                this.avoid_duplicate = marxism.saleAgain.buyer.avoidDuplicate;
            }
        }
    }
</script>

<style scoped>

</style>
